import { render, staticRenderFns } from "./ShareFacebook.vue?vue&type=template&id=bf8891f8&scoped=true&"
import script from "./ShareFacebook.vue?vue&type=script&lang=js&"
export * from "./ShareFacebook.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf8891f8",
  null
  
)

export default component.exports